import { COLORS_CONFIG, DEFAULT_COLORS, DEFAULT_COLORS_WIDGETS, DEFAULT_GROUP_KEYS, DEFAULT_GROUP_LABELS, DEFAULT_SCALE_3_COLORS } from "@components/widgets/apacheEchart/Commons"


export const widgetsBars: CommonWidget = {


  /**************************************************************************
   *                                BARS
  ***************************************************************************/

  barByGeo: {
    title: 'FALTA',
    position: [0, 0],
    size: [0, 0],
    config: {
      id: 'bar-by-geo',
      type: 'bar',
      showHistoric: false,
      showValues: true,
      showLegend: true,
      fillMode: 'solid',
      percentageScale: true,
      itemsWidth: 200,
      nps: false,
      colors: DEFAULT_COLORS,
      mapper: (data: any, extra: any) => {
        //console.log('bar-by-geo')
        //console.log(data)
        return data
      },
      indicators: [
        {
          indicator: 'FALTA',
          grouped: 'geoLocation',
          keyExtract: ['count', 'group', 'groupName', 'value','metricTargets'],
          label: 'group',
          value: 'value',
          singleton: true,
          sort: { sortBy: 'group', value: 'asc' },
        },
      ],
    },
  },

  barByTag: {
    title: 'FALTA',
    position: [0, 0],
    size: [0, 0],
    config: {
      id: 'bar-by-tag',
      type: 'bar',
      showHistoric: false,
      showValues: true,
      showLegend: true,
      fillMode: 'solid',
      percentageScale: true,
      itemsWidth: 200,
      nps: false,
      colors: DEFAULT_COLORS_WIDGETS,
      rotateLabel: 90,
      rotateXAxisLegend: true,
      wrapTexts: true,
      decimals: 0,
      mapper: (data: any): any => {
        return data?.map((item: any) => ({
          ...item,
          label: item.group,
          value: item.count
        })).slice(0, 15)
      },
      indicators: [
        {
          indicator: 'WORD_COUNT',
          grouped: 'tag',
          keyExtract: ['count', 'value', 'group'],
          singleton: true
        },
      ],
    },
  },

  barByCategory: {
    title: 'FALTA',
    position: [0, 0],
    size: [0, 0],
    config: {
      id: 'bar-by-tag',
      type: 'bar',
      showHistoric: false,
      showValues: false,
      showLegend: true,
      fillMode: 'solid',
      percentageScale: true,
      itemsWidth: 200,
      nps: false,
      colors: DEFAULT_SCALE_3_COLORS,
      wrapTexts: true,
      decimals: 0,
      groupKeys: DEFAULT_GROUP_KEYS,
      groupLabels: DEFAULT_GROUP_LABELS,
      mapper: (data: any): any => {
        //console.log('barByCategory Mapper')
        //console.log(data)
        return (data?.[0]?.value ?? data?.[0]?.categories)
          .asMutable()
          .sort((cat1: any, cat2: any) => cat2.count - cat1.count)
          .slice(0, 15)
      },
      indicators: [
        {
          indicator: 'SENTIMENT',
          grouped: 'tag',
          keyExtract: ['categories'],
          value: 'categories',
          singleton: true,
          sort: { sortBy: 'group', value: 'asc' },
        },
      ],
    },
  },
  barByQuestion: {
    title: 'FALTA',
    position: [0, 0],
    size: [0, 0],
    config: {
      id: 'bar-by-question',
      type: 'bar',
      percentageScale: false,
      showValues: true,
      indicators: [
        {
          indicator: 'FALTA',
          keyExtract: [
            'value',
            'group',
            'count',
          ],
          label: 'group',
          grouped: 'question',
          value: 'value',
          singleton: true,
          extras: {
            groupNameFormat: 'description',
          },
        },
      ],
    },
  },
  barByQuestionNps: {
    title: 'FALTA',
    position: [0, 0],
    size: [0, 0],
    config: {
      id: 'bar-by-question-nps',
      type: 'bar',
      percentageScale: false,
      showValues: true,
      colors: DEFAULT_SCALE_3_COLORS,
      groupKeys: ['promoters', 'passives', 'detractors'],
      groupLabels: {
        promoters: 'Positivos',
        passives: 'Neutros',
        detractors: 'Negativos',
      },
      mapper: (data: any, extra: any): any => {
        console.log('barByQuestion Mapper')
        console.log(data)
        console.log(extra)
        return data.map((item: any) => {
          //add validation to cases when 
          //item.label could be 'undefined or not did nto match
          //with groupLabels
          const label = extra?.config?.groupLabels?.[item.group]
          return {
            ...item,
            group: label ?? item.group,
            label: label ?? item.group,
          }
        })
      },
      indicators: [
        {
          indicator: 'FALTA',
          keyExtract: [
            'value',
            'group',
            'count',
            'passives',
            'detractors',
            'promoters',
            'passiveCount',
            'detractorCount',
            'promoterCount',
            'groupName',
            'groupId',
            'groupId_0', 
            'groupId_1'
          ],
          label: 'group',
          grouped: 'question',
          value: 'value',
          singleton: true,
          extras: {
            groupNameFormat: 'description',
          },
        },
      ],
    },
  },
  barByQuestionNpsTransformed: {
    title: 'FALTA',
    position: [0, 0],
    size: [0, 0],
    config: {
      id: 'bar-by-question-nps',
      type: 'bar',
      percentageScale: false,
      showValues: true,
      colors: DEFAULT_SCALE_3_COLORS,
      groupKeys: ['promoters', 'detractors', 'passives'],
      groupLabels: {
        promoters: 'Positivos',
        detractors: 'Negativos',
        passives: 'Neutros',
      },
      mapper: (data: any, extra: any): any => {
        const result: any[] = [];

        data.forEach((item: any) => {

          const rawLabel = extra?.config?.groupLabels?.[item.group] ?? item.group;
          const words = rawLabel.split(' ');
          let questionLabel = rawLabel;

          if (words.length > 2) {
            const middle = Math.ceil(words.length / 2);
            questionLabel = words.slice(0, middle).join(' ') + '\n' + words.slice(middle).join(' ');
          }

          result.push(
            {
              group: questionLabel,
              promoters: Number(item.promoters) || 0,
              passives: Number(item.passives) || 0,
              detractors: Number(item.detractors) || 0,
            }
          );
        });
        return result;
      },
      indicators: [
        {
          indicator: 'FALTA',
          keyExtract: [
            'value',
            'group',
            'count',
            'passives',
            'detractors',
            'promoters',
            'passiveCount',
            'detractorCount',
            'promoterCount',
            'groupName',
          ],
          label: 'group',
          grouped: 'question',
          value: 'value',
          singleton: true,
          extras: {
            groupNameFormat: 'description',
          },
        },
      ],
    },
  },
  barByLogical: {
    title: 'FALTA',
    position: [0, 0],
    size: [0, 0],
    config: {
      id: 'bar-by-logical',
      type: 'bar',
      percentageScale: false,
      showValues: true,
      indicators: [
        {
          indicator: 'FALTA',
          keyExtract: ['value', 'group', 'count'],
          label: 'group',
          grouped: 'logicalLocation',
          value: 'value',
          singleton: true,
          extras: {
            groupNameFormat: 'description',
          },
        },
      ],
    },
  },
  barByChannel: {
    title: 'FALTA',
    position: [0, 0],
    size: [0, 0],
    config: {
      id: 'bar-by-channel',
      type: 'bar',
      percentageScale: false,
      showValues: true,
      colors: ['#DB7476', '#88DD76'],
      indicators: [
        {
          indicator: 'FALTA',
          keyExtract: ['value', 'group', 'count'],
          label: 'group',
          grouped: 'channel',
          value: 'value',
          singleton: true,
          extras: {
            groupNameFormat: 'description',
          },
        },
      ],
    },
  },

  alertFirstResponseBarByWeek: {
    title: 'Tiempo de respuesta alertas semanal. Base 36 hs.',
    helpLink: '--',
    position: [0, 32],
    size: [4, 2],
    config: {
      id: 'alert-first-response-bar-by-week',
      type: 'bar',
      showHistoric: false,
      showValues: true,
      showLegend: true,
      groupKeys: ['slowPerc', 'fastPerc'],
      fillMode: 'solid',
      percentageScale: true,
      nps: false,
      itemsWidth: 200,
      colors: [DEFAULT_COLORS[1], DEFAULT_COLORS[0]],
      groupLabels: {
        fastPerc: 'Respuesta menor a 36 hrs',
        slowPerc: 'Respuesta mayor a 36 hrs',
      },
      indicators: [
        {
          indicator: 'alert-first-response-time',
          grouped: 'formattedWeek',
          keyExtract: ['count', 'fastPerc', 'slowPerc', 'group'],
          label: 'group',
          value: 'value',
          singleton: true,
          sort: { sortBy: 'group', value: 'asc' },
          extras: {
            alertStatus: 'IN_PROCESS,CLOSED'
          },
        },
      ],
    },
  },

  alertFirstResponseBarByMonth: {
    title: 'Tiempo de respuesta alertas mensual. Base 36 hs.',
    helpLink: '--',
    position: [0, 34],
    size: [4, 2],
    config: {
      id: 'alert-first-response-bar-by-month',
      type: 'bar',
      showHistoric: false,
      showValues: true,
      showLegend: true,
      groupKeys: ['slowPerc', 'fastPerc'],
      fillMode: 'solid',
      percentageScale: true,
      itemsWidth: 200,
      nps: false,
      colors: [DEFAULT_COLORS[1], DEFAULT_COLORS[0]],
      groupLabels: {
        fastPerc: 'Respuesta menor a 36 hrs',
        slowPerc: 'Respuesta mayor a 36 hrs',
      },
      indicators: [
        {
          indicator: 'alert-first-response-time',
          grouped: 'formattedMonth',
          keyExtract: ['count', 'fastPerc', 'slowPerc', 'group', 'groupName'],
          label: 'groupName',
          value: 'value',
          singleton: true,
          sort: { sortBy: 'group', value: 'asc' },
          extras: {
            alertStatus: 'IN_PROCESS,CLOSED'
          },
        },
      ],
    },
  },
  alertFirstResponseBarByGeo: {
    title: 'Tiempo de respuesta alertas por geo. Base 36 hs.',
    helpLink: '--',
    position: [0, 36],
    size: [4, 2],
    config: {
      id: 'alert-first-response-bar-by-geo',
      type: 'bar',
      showHistoric: false,
      showValues: true,
      showLegend: true,
      groupKeys: ['slowPerc', 'fastPerc'],
      fillMode: 'solid',
      percentageScale: true,
      itemsWidth: 200,
      nps: false,
      colors: [DEFAULT_COLORS[1], DEFAULT_COLORS[0]],
      groupLabels: {
        fastPerc: 'Respuesta menor a 36 hrs',
        slowPerc: 'Respuesta mayor a 36 hrs',
      },
      mapper: (data: any, extra: any) => {
        return data
      },
      indicators: [
        {
          indicator: 'alert-first-response-time',
          grouped: 'geoLocation',
          keyExtract: ['count', 'fastPerc', 'slowPerc', 'group', 'groupName'],
          label: 'group',
          value: 'value',
          singleton: true,
          sort: { sortBy: 'group', value: 'asc' },
          extras: {
            alertStatus: 'IN_PROCESS,CLOSED',
          },
        },
      ],
    },
  },

  barByMonthRegression: {
    title: 'FALTA',
    helpLink: '--',
    position: [0, 0],
    size: [0, 0],
    config: {
      id: 'bar-by-month-regression',
      type: 'bar',
      showHistoric: false,
      showValues: true,
      indicators: [
        {
          indicator: 'FALTA',
          grouped: 'formattedMonth',
          keyExtract: [
            'group',
            'value',
            'groupName',
            'source',
            'nextX',
            'nextY',
          ],
          label: 'group',
          value: 'value',
          singleton: true,
          sort: { sortBy: 'group', value: 'asc' },
          extras: {
            periods: '3',
          },
        },
      ],
    },
  },
  stackedBar: {
    title: 'FALTA',
    helpLink: '--',
    position: [0, 18],
    size: [4, 1],
    config: {
      id: 'FALTA',
      type: 'stackedBar',
      colors: ['#669D20', '#D6EE4B', '#FFD01B', '#FF0000', '#990001'],
      fillMode: '',
      showValues: true,
      showHistoric: false,
      showLegend: true,
      valueFormat: ' >-.0%',
      indicators: [
        {
          indicator: 'FALTA',
          keyExtract: ['group', 'groupId', 'count', 'value',
            'groupName', 'group_1', 'groupId_0', 'groupId_1'],
          label: 'group',
          value: 'value',
          singleton: true,
          extras: {
            groupNameFormat: 'description',
            formula: 'count-number'
          }
        }
      ]
    }
  },
  stackedBarAlertManagement: {
    title: 'FALTA',
    helpLink: '--',
    position: [0, 18],
    size: [4, 1],
    config: {
      id: 'FALTA',
      type: 'stackedBar',
      colors: {
        vfast: '#362886ff',
        fast: '#D6EE4B',
        meddium: '#FFD01B',
        slow: '#FF0000'
      },
      groupLabels: {
        vfast: 'Menos de 48 hs.',
        fast: '49 hs / 120 hs',
        meddium: '121 hs / 360 hs',
        slow: 'Más de 360 hs'
      },
      fillMode: '',
      showValues: true,
      showHistoric: false,
      showLegend: true,
      valueFormat: ' >-.0%',
      /*,
      ,*/
      mapper: (data: any, extra: any): any => {
        console.log('Alerts counters mapper')
        console.log(data)
        console.log(extra)

        const groupKeys = ['vfast', 'fast', 'meddium', 'slow']

        const groupLabels: Record<string, string> = {
          vfast: 'Menos de 48 hs.',
          fast: '49 hs / 120 hs',
          meddium: '121 hs / 360 hs',
          slow: 'Más de 360 hs'
        }

        return groupKeys.map((item: string, idx: number) => ({
          group: groupLabels[item],
          label: groupLabels[item],
          groupId: item,
          id: idx,
          order: idx,
          value: data?.[0]?.[item + 'Perc'],
          count: data?.[0]?.[item + 'Count']
        }))
      },
      indicators: [
        {
          indicator: 'FALTA',
          keyExtract: [
            'count',
            'fastCount',
            'fastPerc',
            'meddiumCount',
            'meddiumPerc',
            'slowCount',
            'slowPerc',
            'vfastCount',
            'vfastPerc'
          ],
          label: 'group',
          value: 'value',
          singleton: true,
          extras: {
            groupNameFormat: 'description',
            formula: 'alertManagementTime'
          }
        }
      ]
    }
  },
  verticalStackedBar: {
    title: 'FALTA',
    helpLink: '--',
    position: [0, 18],
    size: [4, 1],
    config: {
      id: 'FALTA',
      type: 'stackedBar',
      colors: ['#669D20', '#D6EE4B', '#FFD01B', '#FF0000', '#990001'],
      fillMode: '',
      showValues: true,
      showHistoric: false,
      showLegend: true,
      valueFormat: ' >-.0%',
      itemWidth: 220,
      indicators: [
        {
          indicator: 'FALTA',
          keyExtract: ['group', 'groupId', 'count', 'value', 'groupName', 'group_1', 'group_0'],
          label: 'group',
          value: 'value',
          singleton: true,
          extras: {
            groupNameFormat: 'description',
            formula: 'count-number'
          }
        }
      ]
    }
  },
  horizontalStackedBar: {
    title: 'FALTA',
    helpLink: '--',
    position: [0, 18],
    size: [4, 1],
    config: {
      id: 'FALTA',
      type: 'bar',
      colors: ['#669D20', '#D6EE4B', '#FFD01B', '#FF0000', '#990001'],
      fillMode: '',
      showValues: true,
      showHistoric: false,
      showLegend: true,
      valueFormat: ' >-.0%',
      itemWidth: 220,
      indicators: [
        {
          indicator: 'FALTA',
          keyExtract: ['group', 'groupId', 'count', 'value', 'groupName',
            'group_1', 'group_0', 'groupId_0', 'groupId_1'],
          label: 'group',
          value: 'value',
          singleton: true,
          extras: {
            groupNameFormat: 'description',
            formula: 'count-number'
          }
        }
      ]
    }
  },
/*
horizontalNpsStackedBar: {
    title: 'FALTA',
    helpLink: '--',
    position: [0, 18],
    size: [4, 1],
    config: {
      id: 'FALTA',
      type: 'bar',
      colors: ['#669D20', '#D6EE4B', '#FFD01B', '#FF0000', '#990001'],
      fillMode: '',
      showValues: true,
      showHistoric: false,
      showLegend: true,
      valueFormat: ' >-.0%',
      itemWidth: 220,


      groupKeys: ['promoters', 'detractors', 'passives'],
      groupLabels: {
        promoters: 'Positivos',
        detractors: 'Negativos',
        passives: 'Neutros',
      },
      mapper: (data: any, extra: any): any => {
        console.log('barByQuestion Mapper')
        console.log(data)
        console.log(extra)
        return data.map((item: any) => {
          //add validation to cases when 
          //item.label could be 'undefined or not did nto match
          //with groupLabels
          const label = extra?.config?.groupLabels?.[item.group]
          return {
            ...item,
            group: label ?? item.group,
            label: label ?? item.group,
          }
        })
      },
      indicators: [
        {
          indicator: 'FALTA',
          keyExtract: [
            'value',
            'group',
            'count',
            'passives',
            'detractors',
            'promoters',
            'passiveCount',
            'detractorCount',
            'promoterCount',
            'groupName',
            'groupId',
            'groupId_0', 
            'groupId_1'
          ],
          label: 'group',
          //grouped: 'question',
          value: 'value',
          singleton: true,
          extras: {
            groupNameFormat: 'description',
            formula: 'nps-10'
          }
        }
      ]
    }
  },
*/










  barDetailedByMonthAndGeo: {
    title: 'FALTA',
    // [Column, Row]
    position: [0, 0],
    size: [4, 3],
    config: {
      id: 'bar-detailed-by-month-and-geo',
      type: 'barDetailed',
      fillMode: '',
      colors: COLORS_CONFIG,
      showValues: false,
      wrapTexts: true,
      shadow: false,
      rotateXAxisLegend: true,
      indicators: [
        {
          indicator: 'FALTA',
          grouped: 'formattedMonth,geoLocation',
          keyExtract: ['group_0', 'group_1', 'groupId_0', 'value', 'groupName'],
          label: 'group',
          value: 'value',
          sort: { sortBy: 'group_0', value: 'asc' },
          singleton: true,
          extras: {
            periods: 6,
          },
        },
      ],
    },
  },
  barByMonth: {
    title: 'FALTA',
    // [Column, Row]
    position: [0, 0],
    size: [4, 3],
    config: {
      id: 'bar-detailed-by-geo',
      //type: 'barDetailed',
      type: 'bar',
      fillMode: '',
      colors: COLORS_CONFIG,
      showValues: false,
      wrapTexts: false,
      shadow: false,
      indicators: [
        {
          indicator: 'FALTA',
          grouped: 'formattedMonth',
          keyExtract: ['group', 'group_0', 'group_1', 'groupId_0', 'value', 'groupName'],
          label: 'group',
          value: 'value',
          sort: { sortBy: 'group', value: 'asc' },
          singleton: true,
          extras: {
            periods: 6,
          },
        },
      ],
    },
  },
  alertBarByWeek: {
    title: 'Alertas por semana',
    helpLink: '--',
    position: [0, 36],
    size: [4, 2],
    config: {
      id: 'alert-bar-by-week',
      type: 'bar',
      showHistoric: false,
      showValues: true,
      showLegend: true,
      groupKeys: ['positiveCount', 'negativeCount'],
      fillMode: 'solid',
      percentageScale: true,
      itemsWidth: 200,
      nps: false,
      colors: [DEFAULT_COLORS[1], DEFAULT_COLORS[0]],
      groupLabels: {
        positiveCount: 'WOW',
        negativeCount: 'RESCUE',
      },
      mapper: (data: any, extra: any) => {
        console.log('alert-bar-by-week')
        const finalData = data.map((item: any, idx: number) => {
          return {
            id: idx,
            group: item?.group_0,
            //count: item?.value?.totalCount,
            positiveCount: item?.value?.positiveCount,
            negativeCount: item?.value?.negativeCount,
            label: item?.group_0,
            //value: item?.value?.totalCount
          }
        })
        console.log(data)
        return finalData
      },
      indicators: [
        {
          indicator: 'alert-counters',
          grouped: 'formattedWeek',
          keyExtract: [
            'value',
            'value.totalCount',
            'groupName',
            'group',
            'count',
            'group_0',
            'groupId_1',
            'groupInternalId',
            'group_0',
            'group_1'
          ],
          label: 'group',
          value: 'value',
          singleton: true,
          sort: { sortBy: 'group_0', value: 'asc' },
          extras: {
            groupByLevel: 1
          },
        },
      ],
    },
  },

  alertBarByWeekFull: {
    title: 'Alertas vs Total por Semana',
    helpLink: '--',
    position: [0, 36],
    size: [4, 2],
    config: {
      id: 'alert-bar-by-week-full',
      type: 'bar',
      showHistoric: false,
      showValues: true,
      showLegend: true,
      //groupMode: 'stacked', 
      fillMode: 'solid',
      percentageScale: false,
      // Aquí tus colores que sí se dejaron domar:
      colors: {
        noDetonated: '#a5a1a1',
        wow: '#05491f',
        rescue: '#ee0707'
      },
      groupKeys: ['noDetonated', 'rescue', 'wow'],
      groupLabels: {
        noDetonated: 'Sin Alerta',
        rescue: 'Rescate',
        wow: 'WOW'
      },
      valueFormat: '{c}', // ECharts magic para quitar decimales

      mapper: (data: any, extra: any) => {
        const weekMap: Record<string, any> = {};
        console.log('🔥 Data cruda de los múltiples indicadores:', data);
        // 1. Primero, procesamos el Total (la base de la pirámide)
        const totalData = data['total-data'] || [];
        console.log(' PASO 2 - PRIMER ITEM DE TOTALES:', totalData[0]);

        totalData.forEach((item: any) => {
          const week = item?.group_0 || item?.group || item?.groupName;
          if (!week) return;

          // ¡Adiós decimales! Forzamos el count a entero
          weekMap[week] = {
            week,
            pos: 0,
            neg: 0,
            total: Math.round(Number(item.count) || 0)
          };
        });

        // 2. Luego, procesamos las Alertas y las montamos sobre las semanas
        const alertData = data['alert-data'] || [];
        console.log(' PASO 3 - PRIMER ITEM DE ALERTAS:', alertData[0]);
        alertData.forEach((item: any) => {
          const week = item?.group_0 || item?.group;
          if (!week) return;

          if (!weekMap[week]) {
            console.warn(` ALERTA: La semana "${week}" de alertas NO hizo match con los totales!`);
            weekMap[week] = { week, pos: 0, neg: 0, total: 0 };
          }

          // Leemos las llaves aplanadas por Epsilon y forzamos a entero
          const pos = item['value.positiveCount'] || item?.value?.positiveCount || 0;
          const neg = item['value.negativeCount'] || item?.value?.negativeCount || 0;

          weekMap[week].pos = Math.round(Number(pos));
          weekMap[week].neg = Math.round(Number(neg));
        });
        console.log(' PASO 4 - DICCIONARIO ANTES DE FILTRAR:', weekMap);
        // 3. Calculamos la diferencia y empaquetamos
        const finalData = Object.values(weekMap)
          .sort((a, b) => (a.week > b.week ? 1 : -1))
          .slice(-5)
          .map((item, idx) => {
            // Todo es entero puro aquí
            const noDetonadas = item.total - (item.pos + item.neg);

            return {
              id: idx,
              label: item.week,
              group: item.week,
              wow: item.pos,
              rescue: item.neg,
              noDetonated: noDetonadas > 0 ? noDetonadas : 0
            };
          });
        console.log('🕵️‍♂️ PASO 5 - DATA FINAL QUE VA A LA GRÁFICA:', finalData);
        return finalData;
      },


      indicators: [
        {
          key: 'alert-data',
          indicator: 'alert-counters',
          grouped: 'formattedWeek',
          // ¡CRUCIAL! Le pedimos explícitamente a Epsilon que nos traiga los WOW y Rescates
          keyExtract: [
            'group_0',
            'value.totalCount',
            'value.positiveCount',
            'value.negativeCount'
          ],
          label: 'group',
          value: 'value',
          singleton: true,
          sort: { sortBy: 'group_0', value: 'asc' },
          extras: {
            groupByLevel: 1,
            periods: 8
          }
        },
        {
          key: 'total-data',
          indicator: 'satisfaction',
          grouped: 'formattedWeek',
          // Aseguramos traer el 'count' que es el que nos sirve
          keyExtract: [
            'group_0',
            'group',
            'groupName',
            'count',
            'value'
          ],
          // Le decimos que por defecto use groupName si lo encuentra
          label: 'groupName',
          value: 'value',
          singleton: true,
          sort: { sortBy: 'group_0', value: 'asc' },
          extras: { periods: 8 }
        }
      ]
    }
  },
  alertBarByRegionFull: {
    title: 'Alertas vs Total por Región', // Cambiamos el título
    helpLink: '--',
    position: [0, 36],
    size: [4, 2],
    config: {
      id: 'alert-bar-by-region-full',
      type: 'bar',
      showHistoric: false,
      showValues: true,
      showLegend: true,
      fillMode: 'solid',
      percentageScale: false,
      colors: {
        noDetonated: '#a5a1a1',
        wow: '#05491f',
        rescue: '#ee0707'
      },
      groupKeys: ['noDetonated', 'rescue', 'wow'],
      groupLabels: {
        noDetonated: 'Sin Alerta',
        rescue: 'Rescate',
        wow: 'WOW'
      },
      valueFormat: '{c}',

      mapper: (data: any, extra: any) => {
        const regionMap: Record<string, any> = {};

        // 1. Base de la pirámide (Totales por Región)
        const totalData = data['total-data'] || [];
        totalData.forEach((item: any) => {
          // Extraemos la región (Epsilon suele mandarla en groupName o group para geoLocation)
          const region = item?.groupName || item?.group || item?.group_0;
          if (!region) return;

          regionMap[region] = {
            region,
            pos: 0,
            neg: 0,
            total: Math.round(Number(item.count) || 0)
          };
        });

        // 2. Alertas por Región
        const alertData = data['alert-data'] || [];
        alertData.forEach((item: any) => {
          const region = item?.groupName || item?.group || item?.group_0;
          if (!region) return;

          if (!regionMap[region]) {
            regionMap[region] = { region, pos: 0, neg: 0, total: 0 };
          }

          const pos = item['value.positiveCount'] || item?.value?.positiveCount || 0;
          const neg = item['value.negativeCount'] || item?.value?.negativeCount || 0;

          regionMap[region].pos = Math.round(Number(pos));
          regionMap[region].neg = Math.round(Number(neg));
        });

        // 3. Calculamos la diferencia y empaquetamos
        const finalData = Object.values(regionMap)
          .sort((a, b) => (a.region > b.region ? 1 : -1)) // Ordenamos por nombre de región
          .map((item, idx) => {
            const noDetonadas = item.total - (item.pos + item.neg);

            return {
              id: idx,
              label: item.region, // El eje X ahora dice "Norte", "Sur", etc.
              group: item.region,
              wow: item.pos,
              rescue: item.neg,
              noDetonated: noDetonadas > 0 ? noDetonadas : 0
            };
          });

        return finalData;
      },

      indicators: [
        {
          key: 'alert-data',
          indicator: 'alert-counters',
          grouped: 'geoLocation', // <-- CAMBIO 1: Agrupamos por región
          keyExtract: [
            'group_0', 'group', 'groupName', // Aseguramos capturar el nombre
            'value.totalCount', 'value.positiveCount', 'value.negativeCount'
          ],
          label: 'groupName',
          value: 'value',
          singleton: true,
          sort: { sortBy: 'groupName', value: 'asc' },
          extras: {
            groupByLevel: 1,
            periods: 1 // <-- CAMBIO 2: Solo el periodo actual
          }
        },
        {
          key: 'total-data',
          indicator: 'satisfaction',
          grouped: 'geoLocation', // <-- CAMBIO 1: Agrupamos por región
          keyExtract: ['group_0', 'group', 'groupName', 'count', 'value'],
          label: 'groupName',
          value: 'value',
          singleton: true,
          sort: { sortBy: 'groupName', value: 'asc' },
          extras: {
            groupByLevel: 1,
            periods: 1 // <-- CAMBIO 2: Solo el periodo actual
          }
        }
      ]
    }
  },
}
